import React__default from 'react';

/**
 * Render the container for the weeks in the month grid.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */
function Weeks(props) {
    return React__default.createElement("tbody", { ...props });
}

export { Weeks };
